import React, { useEffect } from 'react';

const HiddenIdFormControl = (props) => {
  useEffect(() => {
    if (!props.formData) props.onChange(Date.now().toString());
    // eslint-disable-next-line
  }, []);

  return (
    <div className='hidden'>
      <input id={props.idSchema.$id} type='hidden' value={props.formData || ''} />
    </div>
  );
};

export default HiddenIdFormControl;
